import graphql from "babel-plugin-relay/macro";

const StockFilterQuery = graphql`
query StockFilterQuery(
    $lowToHigh: Boolean   
    $age_Lte: Int
    $age_Gte: Int
    $popularity: Boolean
    $recommended: Boolean
    $party: ID
    $isInNews: Boolean
    $collection: ID
){
  politicianFilter(
    lowToHigh: $lowToHigh   
    age_Lte: $age_Lte
    age_Gte: $age_Gte
    popularity: $popularity
    recommended: $recommended
    party: $party
    isInNews: $isInNews
    collection:$collection
  ){
    edges{
      node{       
         id
        name
        party{
          partyName
        }
        price
        politicianImage
      
         upcoming
        upcomingStocks
        upcomingStocksSubscribed  
        
      }
    }
  }
}
`

export default StockFilterQuery
// stockOwnedCount
//  priceDiff